// extracted by mini-css-extract-plugin
module.exports = {"responsiveVideo":"EbikeDisplay_responsiveVideo__1jrVE"};